// Check if all characters in search appear in order in text (fuzzy matching)
// Returns true if all characters in search appear in order in text, even with missing letters
export const fuzzyMatch = (text, search) => {
  const textLower = text.toLowerCase();
  const searchLower = search.toLowerCase();
  let textIndex = 0;
  
  for (let i = 0; i < searchLower.length; i++) {
    const searchChar = searchLower[i];
    const foundIndex = textLower.indexOf(searchChar, textIndex);
    if (foundIndex === -1) {
      return false;
    }
    textIndex = foundIndex + 1;
  }
  
  return true;
};

// Calculate match score for finding the best match in search
export const calculateMatchScore = (text, search) => {
  const textLower = text.toLowerCase();
  const searchLower = search.toLowerCase();
  
  // Exact match gets highest score
  if (textLower === searchLower) return 100;
  
  // Starts with search gets high score
  if (textLower.startsWith(searchLower)) return 90;
  
  // Word boundary match gets higher score than general contains
  const words = textLower.split(/\s+/);
  const wordMatch = words.some(word => word.startsWith(searchLower));
  if (wordMatch) return 80;
  
  // Contains search gets medium score
  if (textLower.includes(searchLower)) return 60;
  
  // Fuzzy/acronym match gets lower score (finds matches even with missing letters)
  if (fuzzyMatch(text, search)) return 40;
  
  return 0;
};

